import { render, staticRenderFns } from "./ProductManagementComp.vue?vue&type=template&id=5f6b0a88"
import script from "./ProductManagementComp.vue?vue&type=script&lang=js"
export * from "./ProductManagementComp.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementComp.vue?vue&type=style&index=0&id=5f6b0a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports